<app-sharepoint-table #involvedGrid class="assignment-inolved-table" *ngIf="_configuration" [configuration]="_configuration"
  (onTooolbarButtonClick)="onTooolbarButtonClick($event)">
</app-sharepoint-table>
